import { msg } from "@lingui/core/macro";
import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { useSession } from "@/lib/auth";
import { TodoListView } from "@/features/todos/components/todo-list-view";
import { getTodosCountQuery, getTodosQuery } from "@listto/shared";
import { ListTodo } from "lucide-solid";

import type { PowerSyncDrizzleDB } from "@listto/powersync";

import { useI18n } from "@/providers/i18n-provider";

function TodosPage() {
  const { t } = useI18n();
  const session = useSession();
  const { userId } = session;

  return (
    <>
      <TodoListView
        title={t(msg`Tasks`)}
        icon={ListTodo}
        userId={userId()}
        queryFn={(db: PowerSyncDrizzleDB, uid: string, options) => getTodosQuery(db, uid, options)}
        countQueryFn={(db, uid) => getTodosCountQuery(db, uid)}
        emptyMessage={t(msg`No tasks in your main list.`)}
        listId="all"
      />
      <Outlet />
    </>
  );
}

export const todosRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/all",
  component: TodosPage,
});
